module.exports = __webpack_public_path__ + "static/cr-excellent-474e76371cd9794ca79a7cb591416f89.png";